import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-681595fc"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 1,
  class: "more-container"
}
const _hoisted_2 = ["id", "onClick"]
const _hoisted_3 = { class: "more-line-content" }
const _hoisted_4 = { class: "footer" }
const _hoisted_5 = { class: "version" }
const _hoisted_6 = {
  key: 0,
  class: "cache-info"
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("small", null, "Offline data is currently caching...")
], -1))
const _hoisted_8 = [
  _hoisted_7
]
const _hoisted_9 = {
  key: 1,
  class: "cache-info"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_OfflinePage = _resolveComponent("OfflinePage")!
  const _component_Loading = _resolveComponent("Loading")!
  const _component_FontAwesomeIcon = _resolveComponent("FontAwesomeIcon")!
  const _component_Typography = _resolveComponent("Typography")!

  return (_openBlock(), _createElementBlock("div", null, [
    (!_ctx.hasNetworkConnection)
      ? (_openBlock(), _createBlock(_component_OfflinePage, { key: 0 }))
      : (_openBlock(), _createElementBlock("div", _hoisted_1, [
          (_ctx.loading)
            ? (_openBlock(), _createBlock(_component_Loading, {
                key: 0,
                loading: _ctx.loading
              }, null, 8, ["loading"]))
            : _createCommentVNode("", true),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.moreOptions, (option) => {
            return (_openBlock(), _createElementBlock(_Fragment, null, [
              (option.available)
                ? (_openBlock(), _createElementBlock("div", {
                    id: option.id,
                    key: option.id,
                    class: "more-line-container",
                    onClick: option.onClick
                  }, [
                    _createElementVNode("div", _hoisted_3, [
                      _createVNode(_component_Typography, {
                        class: "more-line-row",
                        variant: "body2"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_FontAwesomeIcon, {
                            class: "more-line-icon",
                            icon: option.icon
                          }, null, 8, ["icon"]),
                          _createTextVNode(" " + _toDisplayString(option.text), 1)
                        ], undefined, true),
                        _: 2
                      }, 1024)
                    ])
                  ], 8, _hoisted_2))
                : _createCommentVNode("", true)
            ], 64))
          }), 256)),
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", null, _toDisplayString(_ctx.domain), 1),
              _createElementVNode("div", null, _toDisplayString(_ctx.decodeUserName) + " | " + _toDisplayString(_ctx.userId), 1),
              _createElementVNode("div", null, "v" + _toDisplayString(_ctx.version), 1),
              (_ctx.currentlyCaching)
                ? (_openBlock(), _createElementBlock("div", _hoisted_6, _hoisted_8))
                : (_ctx.lastDataCached > 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                      _createElementVNode("div", null, [
                        _createElementVNode("small", null, "Offline data cached: " + _toDisplayString(_ctx.fLastDataCached), 1)
                      ]),
                      _createElementVNode("div", null, [
                        _createElementVNode("small", null, "Time used caching: " + _toDisplayString(_ctx.lastTimeSpent), 1)
                      ]),
                      _createElementVNode("div", null, [
                        _createElementVNode("small", null, "Cached size: " + _toDisplayString(_ctx.lastDataSize), 1)
                      ])
                    ]))
                  : _createCommentVNode("", true)
            ])
          ])
        ]))
  ]))
}